var m = Object.defineProperty;
var v = (i, e, t) => e in i ? m(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var n = (i, e, t) => (v(i, typeof e != "symbol" ? e + "" : e, t), t);
import f from "inputmask/dist/inputmask.es6.js";
class p {
  constructor(e) {
    n(this, "options", {});
    n(this, "container", null);
    n(this, "scriptPromises", []);
    this.initOptions(e), this.initSocials(e);
  }
  static make(e) {
    const t = new this(e);
    return t.init(), t;
  }
  getTelegramEl() {
    return this.getEl().querySelector("[data-telegram]");
  }
  getWhatsappEl() {
    return this.getEl().querySelector("[data-whatsapp]");
  }
  getViberEl() {
    return this.getEl().querySelector("[data-viber]");
  }
  initContainer(e, t) {
    this.container = document.createElement("div"), this.container.classList.add(e), this.container.innerHTML = t(this.options), document.body.appendChild(this.container);
  }
  destroyContainer() {
    this.container.remove();
  }
  initOptions(e) {
    this.options = e;
  }
  initSocials(e) {
    e.socials || (this.options.socials = {});
    const { socials: t } = this.options;
    t.telegram || (t.telegram = {});
    const { telegram: s } = t;
    s.href || (s.href = "https://t.me/OsnovaChatPlatformBot"), t.whatsapp || (t.whatsapp = {});
    const { whatsapp: a } = t;
    a.href || (a.href = "https://wa.me/79030155954"), t.viber || (t.viber = {});
    const { viber: o } = t;
    o.href || (o.href = "viber://pa?chatURI=osnovachatbot");
  }
  listenSocials() {
    this.getTelegramEl().addEventListener("click", async () => {
      await this.waitScripts(), window.createCustomerSession("telegram", "OsnovaChatPlatformBot"), this.pushTelegram();
    }), this.getWhatsappEl().addEventListener("click", async () => {
      await this.waitScripts(), window.createCustomerSession("whatsApp", "gkosnova_WA"), this.pushWhatsapp();
    }), this.getViberEl().addEventListener("click", async () => {
      await this.waitScripts(), window.createCustomerSession("viber", "osnovachatbot"), this.pushViber();
    });
  }
  pushTelegram(e) {
    window.dataLayer.push({ ...e, event: "clickTelegram" });
  }
  pushWhatsapp(e) {
    window.dataLayer.push({ ...e, event: "clickWhatsapp" });
  }
  pushViber(e) {
    window.dataLayer.push({ ...e, event: "clickViber" });
  }
  waitScripts() {
    return Promise.all(this.scriptPromises);
  }
  loadScripts() {
    const e = "https://config.nikfort.ru/js/osnova";
    if (document.body.querySelector("script[data-chat-script]"))
      return;
    [
      `${e}/zone.min.js`,
      `${e}/nf-cpw-starter.js`,
      `${e}/nf-cpw-session.js`
    ].forEach((s) => {
      const a = document.createElement("script");
      a.src = s, a.dataset.chatScript = "", this.scriptPromises.push(
        new Promise((o, c) => {
          a.onload = o, a.onerror = c;
        })
      ), document.body.appendChild(a);
    });
  }
}
function b(i) {
  return `
  <div id="${i.callbackModalId}" class="popup-with-chats popup-with-chats--closed">
    <div role="button" area-label="\u0437\u0430\u043A\u0440\u044B\u0442\u044C" class="popup-with-chats__close" data-close="${i.callbackModalId}">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clip-path="url(#clip0_60_355)">
      <rect x="5.94916" y="8.05093" width="2.81042" height="25.2938" transform="rotate(-45 5.94916 8.05093)" fill="#D6D6D6"/>
      <rect x="7.93652" y="25.9363" width="2.81042" height="25.2938" transform="rotate(-135 7.93652 25.9363)" fill="#D6D6D6"/>
      </g>
      <defs>
      <clipPath id="clip0_60_355">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
      </svg>
    </div>
    <div class="popup-with-chats__wrapper">
      <div class="popup-with-chats__content">
        <div class="popup-with-chats__title" data-popup-with-chats-custom-title></div>
        <div class="popup-with-chats__social" data-popup-with-chats-custom-content></div>
        <div class="popup-with-chats__social" data-popup-with-chats-content>
          <a target="_blank" class="popup-with-chats__soc-button" href="${i.socials.telegram.href}" data-telegram>
            <div class="popup-with-chats__icon" data-icon-wrapper>
              <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.666687 16C0.666687 24.8366 7.83013 32 16.6667 32C25.5032 32 32.6667 24.8366 32.6667 16C32.6667 7.16344 25.5032 0 16.6667 0C7.83013 0 0.666687 7.16344 0.666687 16ZM13.7334 23.3333L14.0056 19.2548L14.0054 19.2547L21.4246 12.5593C21.7502 12.2703 21.3535 12.1294 20.9213 12.3915L11.7649 18.1682L7.80981 16.9338C6.95569 16.6723 6.94955 16.0853 8.00157 15.6634L23.4136 9.72057C24.1175 9.401 24.7969 9.88964 24.5282 10.967L21.9035 23.3354C21.7202 24.2143 21.1892 24.4245 20.4534 24.0185L16.4552 21.0646L14.5334 22.9333C14.5273 22.9392 14.5213 22.9451 14.5153 22.9509C14.3003 23.1602 14.1225 23.3333 13.7334 23.3333Z" fill="#EC6337"/>
              </svg>
            </div>
            <div class="popup-with-chats__name">
              Telegram
            </div>
          </a>
          <a target="_blank" class="popup-with-chats__soc-button" href="${i.socials.whatsapp.href}" data-whatsapp>
            <div class="popup-with-chats__icon" data-icon-wrapper>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16ZM26.0414 15.3877C26.0393 20.6322 21.773 24.8995 16.5274 24.9017H16.5234C14.9311 24.9011 13.3665 24.5016 11.9769 23.7436L6.93333 25.0667L8.28308 20.1366C7.45049 18.6937 7.01239 17.057 7.0131 15.3802C7.01519 10.1345 11.2832 5.86667 16.5273 5.86667C19.0724 5.86777 21.4612 6.85858 23.2575 8.65694C25.0537 10.4552 26.0424 12.8456 26.0414 15.3877Z" fill="#EC6337"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.21765 22.8064L12.2106 22.0213L12.4993 22.1926C13.7134 22.9131 15.1052 23.2944 16.5242 23.2949H16.5274C20.8859 23.2949 24.4333 19.7474 24.435 15.3871C24.4358 13.2741 23.6141 11.2874 22.1211 9.79267C20.6281 8.29794 18.6426 7.47437 16.5305 7.47363C12.1686 7.47363 8.62118 11.0207 8.61945 15.3807C8.61883 16.8749 9.03691 18.3301 9.82849 19.5891L10.0165 19.8883L9.21765 22.8064ZM20.9949 17.436C21.1607 17.5162 21.2727 17.5703 21.3205 17.6501C21.3799 17.7492 21.3799 18.2252 21.1819 18.7806C20.9837 19.3359 20.034 19.8427 19.5773 19.9109C19.1677 19.9721 18.6494 19.9977 18.08 19.8167C17.7347 19.7071 17.2919 19.5609 16.7247 19.3159C14.4961 18.3536 12.99 16.1936 12.7054 15.7854C12.6854 15.7568 12.6715 15.7368 12.6637 15.7264L12.6618 15.7238C12.536 15.556 11.693 14.4312 11.693 13.2672C11.693 12.1722 12.2309 11.5982 12.4785 11.334C12.4955 11.3159 12.5111 11.2993 12.525 11.284C12.7429 11.046 13.0005 10.9865 13.159 10.9865C13.3174 10.9865 13.4761 10.988 13.6146 10.9949C13.6317 10.9958 13.6494 10.9957 13.6678 10.9956C13.8064 10.9948 13.9791 10.9938 14.1494 11.403C14.215 11.5605 14.3109 11.794 14.4121 12.0403C14.6166 12.5383 14.8426 13.0885 14.8824 13.1681C14.9418 13.2871 14.9814 13.4259 14.9022 13.5846C14.8903 13.6084 14.8793 13.6309 14.8688 13.6524C14.8093 13.7739 14.7655 13.8632 14.6645 13.9812C14.6248 14.0276 14.5837 14.0776 14.5427 14.1276C14.4609 14.2272 14.3791 14.3267 14.3079 14.3977C14.1889 14.5162 14.065 14.6448 14.2037 14.8828C14.3423 15.1208 14.8194 15.8993 15.5262 16.5297C16.2858 17.2073 16.9461 17.4937 17.2808 17.6388C17.3461 17.6672 17.3991 17.6901 17.4379 17.7096C17.6755 17.8286 17.8142 17.8087 17.9529 17.6501C18.0916 17.4914 18.5472 16.9559 18.7056 16.718C18.8641 16.4801 19.0226 16.5197 19.2405 16.599C19.4584 16.6784 20.6272 17.2534 20.8649 17.3724C20.9113 17.3956 20.9547 17.4166 20.9949 17.436Z" fill="#EC6337"/>
              </svg>
            </div>
            <div class="popup-with-chats__name">
              WhatsApp
            </div>
          </a>
          <a target="_blank" class="popup-with-chats__soc-button" href="${i.socials.viber.href}" data-viber>
            <div class="popup-with-chats__icon" data-icon-wrapper>
              <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3334 0C25.1699 0 32.3334 7.16344 32.3334 16C32.3334 24.8366 25.1699 32 16.3334 32C7.49682 32 0.333374 24.8366 0.333374 16C0.333374 7.16344 7.49682 0 16.3334 0ZM20.5961 13.9723C20.5183 13.3401 20.324 12.8436 19.9789 12.4039C19.5308 11.8378 18.9582 11.4987 18.1104 11.2976C17.5579 11.1636 17.3347 11.1789 17.1348 11.3615C16.9487 11.5325 16.9124 11.8753 17.0546 12.0973C17.1546 12.2584 17.27 12.3162 17.591 12.3792C18.0184 12.4578 18.3138 12.5599 18.5825 12.7135C19.1527 13.0428 19.4183 13.5581 19.4468 14.3923C19.46 14.784 19.4939 14.9044 19.6307 15.0434C19.8843 15.2973 20.3355 15.2479 20.527 14.944C20.5972 14.8295 20.6079 14.7796 20.6153 14.5136C20.6202 14.349 20.6131 14.1039 20.5961 13.9723ZM20.6037 10.0934C21.9596 11.1899 22.7172 12.7482 22.8298 14.6851C22.8772 15.448 22.8142 15.6965 22.5451 15.838C22.3022 15.9691 22.0271 15.926 21.8383 15.7285C21.7132 15.6001 21.6652 15.4245 21.667 15.1135C21.6725 14.2537 21.4744 13.2935 21.1523 12.6272C20.7795 11.8517 20.2033 11.1917 19.4784 10.7093C18.8435 10.2855 18.0032 9.99926 17.1884 9.92797C16.6599 9.88174 16.4712 9.79223 16.3698 9.53888C16.3069 9.38733 16.3235 9.12532 16.3972 9.00797C16.4669 8.89977 16.6232 8.7801 16.7337 8.74847C16.8508 8.7143 17.5334 8.77403 17.9042 8.84771C18.9164 9.05373 19.8398 9.47736 20.6037 10.0934ZM25.3015 22.1442C25.2637 22.0335 25.1753 21.8627 25.1121 21.7647C24.7142 21.1638 22.5764 19.4908 21.509 18.9437C20.8996 18.6306 20.448 18.5263 20.1133 18.6242C19.7533 18.7255 19.5638 18.8931 18.9607 19.6426C18.7176 19.9431 18.4681 20.2246 18.4018 20.2688C18.2376 20.3827 17.9155 20.4744 17.6881 20.4744C17.1608 20.4712 16.204 20.1297 15.4682 19.6806C14.8966 19.3327 14.1641 18.7097 13.6019 18.093C12.9388 17.3687 12.4873 16.7299 12.1304 16.0088C11.6694 15.0822 11.5525 14.5161 11.7451 14.1018C11.7925 13.9974 11.8557 13.8868 11.8841 13.8519C11.9125 13.8203 12.2094 13.5768 12.5377 13.3111C13.182 12.7988 13.2861 12.6818 13.4061 12.3308C13.5577 11.8848 13.5167 11.4294 13.283 10.9709C13.103 10.623 12.6325 9.86394 12.2915 9.37376C11.8399 8.72861 10.7157 7.34973 10.4915 7.16309C10.0873 6.83421 9.56946 6.77725 8.99784 6.99868C8.39476 7.23271 7.26424 8.14352 6.78108 8.77921C6.34531 9.35478 6.178 9.76274 6.15271 10.3004C6.13062 10.7431 6.1685 10.9266 6.40218 11.4927C8.23054 15.9329 10.9588 19.4782 14.7072 22.2929C16.665 23.7634 18.6954 24.883 20.8017 25.6484C22.0301 26.0943 22.5637 26.1164 23.1921 25.7496C23.4574 25.5914 24.1142 24.9178 24.4805 24.4276C25.0868 23.6116 25.311 23.2353 25.3742 22.9349C25.4184 22.7293 25.3836 22.372 25.3015 22.1442ZM24.4941 12.1337C24.8788 13.1356 25.0632 14.0343 25.1037 15.13C25.1101 15.3464 25.1071 15.7429 25.0931 16.0116C25.0639 16.5265 25.036 16.6288 24.8877 16.7651C24.6494 16.9886 24.185 16.9353 24.0088 16.6659C23.9169 16.5214 23.904 16.4155 23.9217 15.8138C23.9728 14.0342 23.6129 12.6408 22.7458 11.2474C21.7097 9.57579 20.1599 8.44969 18.1446 7.89878C17.6306 7.75855 17.1975 7.67309 16.5239 7.5824C16.0851 7.52497 15.989 7.50068 15.8807 7.43403C15.5536 7.22449 15.5492 6.69391 15.8754 6.48119C16.0436 6.3689 16.1677 6.36388 16.7163 6.43413C18.3248 6.63514 19.7602 7.11311 20.9396 7.83537C21.7849 8.35376 22.3179 8.81946 23.0042 9.63508C23.73 10.505 24.1144 11.1481 24.4941 12.1337Z" fill="#EC6337"/>
              </svg>
            </div>
            <div class="popup-with-chats__name">
              Viber
            </div>
          </a>
        </div>
        <div class="popup-with-chats__form-wrapper" data-popup-with-chats-form>
          <form class="popup-with-chats__form">
            <div data-popup-with-chats-input class="popup-with-chats__field popup-with-chats__field-input">
              <label class="popup-with-chats__label"><span>*</span>\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430</label>
              <input name="phone" required class="popup-with-chats__input">
            </div>
            <div data-popup-with-chats-input class="popup-with-chats__field popup-with-chats__field-input">
              <label class="popup-with-chats__label"><span>*</span>\u0418\u043C\u044F</label>
              <input name="name" required class="popup-with-chats__input">
            </div>
            <input name="ch" class="popup-with-chats__input">
            <div id="popup-with-chats-captcha" class="popup-with-chats__captcha"></div>
            <button class="popup-with-chats__field popup-with-chats__button" data-popup-with-chats-button>\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435</button>
          </form>
        </div>
        <div class="popup-with-chats__agreement">
          \u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \xAB\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435\xBB, \u0412\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441 \u043F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 <a class="popup-with-chats__agreement-link" target="_blank" href="${i.agreementLink}">\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445</a>
        </div>
      </div>
    </div>
  </div>
  <div data-close="${i.callbackModalId}" data-shadow class="popup-with-chats-shandow"></div>
  `;
}
function _(i) {
  return `
  <div id="${i.responseModalId}" class="popup-with-chats popup-with-chats--closed">
    <div role="button" area-label="\u0437\u0430\u043A\u0440\u044B\u0442\u044C" class="popup-with-chats__close" data-close="${i.responseModalId}">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clip-path="url(#clip0_60_355)">
      <rect x="5.94916" y="8.05093" width="2.81042" height="25.2938" transform="rotate(-45 5.94916 8.05093)" fill="#D6D6D6"/>
      <rect x="7.93652" y="25.9363" width="2.81042" height="25.2938" transform="rotate(-135 7.93652 25.9363)" fill="#D6D6D6"/>
      </g>
      <defs>
      <clipPath id="clip0_60_355">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
      </svg>
    </div>
    <div class="popup-with-chats__wrapper">
      <div class="popup-with-chats__content">
        <div class="popup-with-chats__title" data-popup-with-chats-response-title>\u0412\u0430\u0448\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B</div>
        <div class="popup-with-chats__subtitle" data-popup-with-chats-response-subtitle>\u0412 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441 \u0412\u0430\u043C\u0438 \u0441\u0432\u044F\u0436\u0435\u0442\u0441\u044F \u043D\u0430\u0448 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440!</div>
      </div>
    </div>
  </div>
  <div data-close="${i.responseModalId}" class="popup-with-chats-shandow"></div>
  `;
}
class u extends p {
  constructor(e) {
    super(e);
  }
  getEl() {
    return document.querySelector(`#${this.options.responseModalId}`);
  }
  show(e = {}) {
    const { success: t } = e;
    this.options.success = !!t, this.options.success || (this.getEl().querySelector(
      "[data-popup-with-chats-response-title]"
    ).textContent = "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430", this.getEl().querySelector(
      "[data-popup-with-chats-response-subtitle]"
    ).textContent = "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435"), this.getEl().classList.remove("popup-with-chats--closed"), setTimeout(() => {
      this.hide();
    }, 3e3);
  }
  hide() {
    this.getEl().classList.add("popup-with-chats--closed");
  }
  init() {
    this.initContainer("popup-with-chats-container", _), setTimeout(() => {
      this.getEl().querySelectorAll("[data-close]").forEach((e) => {
        e.addEventListener("click", () => {
          this.hide();
        });
      }), document.querySelectorAll(`[data-close="${this.options.responseModalId}"]`).forEach((e) => {
        e.addEventListener("click", () => {
          this.hide();
        });
      });
    }, 0);
  }
}
function E(i, e, t) {
  return new Promise((s, a) => {
    let o = "";
    if (i.name != null && (o += i.name), i.lastName != null && (o += " ", o += i.lastName), i.secondName != null && (o += " ", o += i.secondName), i.inn && (o = o + " | \u0418\u041D\u041D: " + i.inn), !window.Comagic || typeof window.Comagic.addOfflineRequest != "function") {
      a({
        code: -1,
        text: "\u041D\u0435\u0442 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 Comagic \u0432 window"
      });
      return;
    }
    window.Comagic.addOfflineRequest(
      {
        name: "\u0418\u043C\u044F: " + o + " | \u0424\u043E\u0440\u043C\u0430: " + e.replace(/&nbsp;/g, " "),
        phone: i.phone,
        email: i.email,
        message: t.replace(/&nbsp;/g, " "),
        form_name: e.replace(/&nbsp;/g, " ")
      },
      (c) => {
        var h = JSON.parse(c.response);
        h.success === !0 ? (s({
          code: 1,
          text: "<b>" + i.name + '</b>, \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u0437\u0430 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0435. \u041C\u044B \u0441\u0432\u044F\u0436\u0435\u043C\u0441\u044F \u0441 \u0432\u0430\u043C\u0438 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 <b><span style="display: inline-block;">' + i.phone + "</span></b>"
        }), console.log("\u0417\u0430\u044F\u0432\u043A\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430 CoMagic")) : (a({
          code: -1,
          text: "\u041F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u044F\u0432\u043A\u0438 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430, \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435"
        }), console.log("\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0437\u0430\u044F\u0432\u043A\u0438 \u043D\u0430 \u0441\u0442\u043E\u0440\u043E\u043D\u0435 CoMagic"));
      }
    );
  });
}
class w extends p {
  constructor(t) {
    super(t);
    n(this, "captchaId", null);
    n(this, "captcha", {});
    t.captcha && (this.captcha = t.captcha);
  }
  showResponse(t = !1) {
    this.getNameEl().value = "", this.getPhoneEl().value = "", this.getEl().querySelectorAll("input").forEach((s) => {
      s.dispatchEvent(new Event("change"));
    }), this.hide(), this.options.callback && (typeof this.options.callback == "function" ? this.options.callback() : window[this.options.callback] && window[this.options.callback]()), window.dispatchEvent(
      new CustomEvent("popup-with-chats-send", {
        detail: { popupName: this.options.name }
      })
    ), this.responseModal.show({ success: t });
  }
  getEl() {
    return document.querySelector(`#${this.options.callbackModalId}`);
  }
  getNameEl() {
    return this.getEl().querySelector('[name="name"]');
  }
  getPhoneEl() {
    return this.getEl().querySelector('[name="phone"]');
  }
  getHiddenEl() {
    return this.getEl().querySelector('[name="ch"]');
  }
  getBtnEl() {
    return this.getEl().querySelector("[data-popup-with-chats-button]");
  }
  show(t = {}) {
    const {
      sourceId: s,
      name: a,
      title: o,
      customContent: c,
      button: h,
      handler: l,
      callback: r,
      callbackModalClass: d
    } = t;
    this.setCenter(), this.initCaptcha(), this.loadScripts(), this.options.customTitle = o || "", this.options.name = a || "", this.options.sourceId = s || "", this.options.button = h || "\u041F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043C\u043D\u0435", c && (this.options.customContent = c), l && (this.options.handler = l), r && (this.options.callback = r), this.options.callbackModalClass && this.getEl().classList.remove(d), this.options.callbackModalClass = d || "", this.options.callbackModalClass && this.getEl().classList.add(this.options.callbackModalClass), this.getEl().classList.remove("popup-with-chats--closed"), this.options.disableForm || (this.getEl().querySelector("[data-popup-with-chats-button]").innerHTML = this.options.button), this.setCustomContent(), this.setCustomTitle(), this.setShadowContent(), this.setSocialIcons(), window.dispatchEvent(new Event("popup-with-chats-show"), {
      popupName: a
    }), window.dataLayer.push({
      popupName: o,
      event: "open"
    });
  }
  hide() {
    this.getEl().classList.add("popup-with-chats--closed"), window.dispatchEvent(new Event("popup-with-chats-hide"), {
      popupName: this.options.name
    });
  }
  init() {
    this.responseModal = u.make(this.options), this.initContainer("popup-with-chats-container", b), this.getEl().querySelectorAll("[data-close]").forEach((t) => {
      t.addEventListener("click", () => {
        this.hide();
      });
    }), document.querySelectorAll(`[data-close="${this.options.callbackModalId}"]`).forEach((t) => {
      t.addEventListener("click", () => {
        this.hide();
      });
    }), this.getEl().querySelectorAll("[data-popup-with-chats-input]").forEach((t) => {
      t.isFocus = !1, t.addEventListener("click", (s) => {
        t.querySelector("input").focus();
      }), t.querySelector("input").addEventListener("focus", () => {
        t.isFocus = !0, t.classList.add("popup-with-chats__field-input--with-content");
      }), t.querySelector("input").addEventListener("blur", (s) => {
        t.isFocus = !1, t.querySelector("input").dispatchEvent(new Event("change"));
      }), t.querySelector("input").addEventListener("input", (s) => {
        t.classList.remove("popup-with-chats__field-input--error"), t.isFocus || s.target.value ? t.classList.add("popup-with-chats__field-input--with-content") : t.classList.remove("popup-with-chats__field-input--with-content");
      }), t.querySelector("input").addEventListener("change", (s) => {
        t.classList.remove("popup-with-chats__field-input--error"), s.target.value ? t.classList.add("popup-with-chats__field-input--with-content") : t.classList.remove("popup-with-chats__field-input--with-content");
      });
    }), f({
      mask: "+7(999)999-99-99",
      showMaskOnHover: !1
    }).mask(document.querySelectorAll('[name="phone"]')), this.setForm(), this.listenSocials();
  }
  setCenter() {
    this.getEl().style.left = `calc(50% + ${(window.innerWidth - document.documentElement.offsetWidth) / 2}px)`;
  }
  setForm() {
    const t = this.getEl().querySelector("[data-popup-with-chats-form]");
    if (this.options.disableForm)
      return t.remove();
    t.addEventListener("submit", (s) => {
      var o, c;
      if (s.preventDefault(), this.options.handler)
        return this.options.handler({
          name: (o = this.getNameEl().value) != null ? o : "",
          phone: (c = this.getNameEl().value) != null ? c : ""
        }).then(() => this.showResponse(!0)).catch(() => this.showResponse());
      if (this.getPhoneEl().value.replace(/([^+\d]+)/gi, "").length < 12)
        return this.getPhoneEl().parentNode.classList.add(
          "popup-with-chats__field-input--error"
        );
      this.getHiddenEl().value || (this.setLoader(), this.captcha.sitekey ? this.executeCaptcha() : this.send());
    });
  }
  initCaptcha() {
    !this.captcha.sitekey || this.captchaId !== null || (this.captchaId = window.smartCaptcha.render("popup-with-chats-captcha", {
      sitekey: this.captcha.sitekey,
      invisible: !0,
      hideShield: !0
    }), window.smartCaptcha.subscribe(this.captchaId, "success", () => this.send()), window.smartCaptcha.subscribe(
      this.captchaId,
      "challenge-hidden",
      () => this.removeLoader()
    ));
  }
  executeCaptcha() {
    window.smartCaptcha || this.showResponse(), window.smartCaptcha.execute(this.captchaId);
  }
  resetCaptcha() {
    !this.captcha.sitekey || window.smartCaptcha.reset(this.captchaId);
  }
  setLoader() {
    this.getBtnEl().disabled = !0, this.getBtnEl().classList.add(this.constructor.btnLoaderClassName);
  }
  removeLoader() {
    this.getBtnEl().disabled = !1, this.getBtnEl().classList.remove(this.constructor.btnLoaderClassName);
  }
  send() {
    const t = `\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435: ${this.options.subtitle} | URL: ${document.URL} | ID: ${this.options.sourceId !== "" ? this.options.sourceId : this.options.callbackModalId}`;
    let s = this.options.customTitle && this.options.customTitle !== "" ? this.options.customTitle : this.options.title;
    s = s.replace(/<br([\s /]*)>/gi, " "), s = s.replace(/(<[^>]*>)/gi, ""), E(
      {
        name: this.getNameEl().value,
        phone: this.getPhoneEl().value
      },
      s,
      t
    ).then(() => this.showResponse(!0)).catch(() => this.showResponse()).finally(() => {
      this.resetCaptcha(), this.removeLoader();
    });
  }
  setCustomContent() {
    const { customContent: t } = this.options, s = this.getEl().querySelector(
      "[data-popup-with-chats-content]"
    ), a = this.getEl().querySelector(
      "[data-popup-with-chats-custom-content]"
    );
    t ? (s.style.display = "none", a.innerHTML = t, a.style = "") : (s.style = "", a.style.display = "none");
  }
  setCustomTitle() {
    const { title: t, customTitle: s } = this.options, a = this.getEl().querySelector(
      "[data-popup-with-chats-custom-title]"
    );
    a && (a.innerHTML = s && s !== "" ? s : t);
  }
  setShadowContent() {
    const { shadowContent: t } = this.options;
    t && (this.container.querySelector("[data-shadow]").innerHTML = t);
  }
  setSocialIcons() {
    const { telegram: t, whatsapp: s, viber: a } = this.options.socials, o = (c) => c.querySelector("[data-icon-wrapper]");
    t.icon && (o(this.getTelegramEl()).innerHTML = t.icon), s.icon && (o(this.getWhatsappEl()).innerHTML = s.icon), a.icon && (o(this.getViberEl()).innerHTML = a.icon);
  }
  pushTelegram() {
    super.pushTelegram({ popupName: this.options.title });
  }
  pushWhatsapp() {
    super.pushWhatsapp({ popupName: this.options.title });
  }
  pushViber() {
    super.pushViber({ popupName: this.options.title });
  }
}
n(w, "btnLoaderClassName", "popup-with-chats__button--loading");
function L(i) {
  return `
  <div id="${i.buttonId}" class="button-with-chats">
    <input
      id="button-with-chats-input"
      type="checkbox"
      class="button-with-chats__input"
    />
    <label for="button-with-chats-input" class="button-with-chats__label">
      <svg
        role="presentation"
        class="button-with-chats__icon button-with-chats__icon-write"
        width="35"
        height="32"
        viewBox="0 0 35 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2667 12.6981H23.3667M11.2667 16.4717H23.3667M4.8104 23.5777C2.4311 21.1909 1 18.1215 1 14.7736C1 7.16679 8.38723 1 17.5 1C26.6128 1 34 7.16679 34 14.7736C34 22.3804 26.6128 28.5472 17.5 28.5472C15.6278 28.5472 13.8286 28.2868 12.1511 27.8072L12 27.7925L5.03333 31V23.8219L4.8104 23.5777Z"
          stroke="#2e0500"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        ></path>
      </svg>
      <svg
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        class="button-with-chats__icon button-with-chats__icon-close"
        viewBox="0 0 23 23"
      >
        <g fillrule="evenodd">
          <path
            d="M10.314 -3.686H12.314V26.314H10.314z"
            transform="rotate(-45 11.314 11.314)"
          ></path>
          <path
            d="M10.314 -3.686H12.314V26.314H10.314z"
            transform="rotate(45 11.314 11.314)"
          ></path>
        </g>
      </svg>
    </label>
    <a
      href="${i.socials.viber.href}"
      class="button-with-chats__icon button-with-chats__link"
      target="_blank"
      data-viber
    >
      <span class="button-with-chats__tooltip">Viber</span>
      <div class="button-with-chats__svg-wrapper">
        <div class="button-with-chats__svg-bg"></div>
        <svg
          width="50"
          height="50"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50Zm19.546-71.18c-1.304-1.184-6.932-4.72-18.674-4.772 0 0-13.905-.913-20.655 5.2-3.757 3.71-5.022 9.226-5.161 15.957l-.016.691c-.156 6.885-.433 19.013 11.47 22.32l-.053 10.386c0 .587.093.988.428 1.071.241.059.602-.066.91-.372 1.968-1.978 8.271-9.582 8.271-9.582 8.457.553 15.186-1.117 15.91-1.354.17-.054.415-.111.72-.183 2.752-.641 10.37-2.417 11.776-13.773 1.613-13.003-.594-21.88-4.926-25.589ZM48.664 31.51a.908.908 0 0 1 .914-.901c4.585.032 8.468 1.56 11.584 4.597 3.146 3.067 4.696 7.24 4.736 12.404a.908.908 0 1 1-1.815.013c-.037-4.79-1.461-8.458-4.188-11.117-2.757-2.688-6.18-4.053-10.33-4.082a.908.908 0 0 1-.9-.914Zm2.374 2.932a1.15 1.15 0 1 0-.168 2.294c2.918.213 5.067 1.184 6.597 2.854 1.541 1.684 2.304 3.784 2.248 6.389a1.15 1.15 0 0 0 2.3.05c.067-3.133-.87-5.826-2.851-7.992-2.01-2.193-4.758-3.349-8.126-3.595Zm1.156 4.454a.908.908 0 1 0-.095 1.812c1.335.07 2.223.458 2.8 1.054.58.6.964 1.535 1.033 2.936a.908.908 0 0 0 1.813-.09c-.083-1.677-.558-3.09-1.542-4.108-.987-1.021-2.368-1.519-4.009-1.604Zm1.805 15.633c-.594.732-1.698.64-1.698.64-8.066-2.06-10.224-10.23-10.224-10.23s-.097-1.104.638-1.698l1.458-1.158c.722-.557 1.183-1.908.448-3.228a34.125 34.125 0 0 0-1.839-2.881c-.641-.877-2.136-2.671-2.142-2.677-.72-.85-1.78-1.048-2.898-.466a.045.045 0 0 0-.012.003l-.011.003a12.062 12.062 0 0 0-2.986 2.432c-.69.833-1.085 1.65-1.185 2.45a1.57 1.57 0 0 0-.022.357c-.003.354.05.706.16 1.042l.038.026c.348 1.236 1.22 3.296 3.114 6.731a40.117 40.117 0 0 0 3.735 5.654c.703.89 1.456 1.74 2.256 2.543l.029.03.057.056.085.086.086.085.086.086a29.64 29.64 0 0 0 2.543 2.255 40.072 40.072 0 0 0 5.655 3.736c3.433 1.894 5.495 2.766 6.73 3.114l.026.038c.336.11.688.164 1.041.16.12.006.24-.001.358-.022.802-.095 1.618-.49 2.448-1.184a.032.032 0 0 0 .007-.004.101.101 0 0 0 .003-.004l.012-.008a12.09 12.09 0 0 0 2.41-2.97l.003-.01a.054.054 0 0 0 .002-.013c.583-1.117.385-2.177-.47-2.899l-.189-.154c-.484-.4-1.783-1.47-2.487-1.988a34.12 34.12 0 0 0-2.879-1.838c-1.32-.736-2.669-.275-3.228.448L54 54.528Z"
            fill="#7360f2"
          ></path>
        </svg>
      </div>
    </a>
    <a
      href="${i.socials.whatsapp.href}"
      class="button-with-chats__icon button-with-chats__link"
      target="_blank"
      data-whatsapp
    >
      <span class="button-with-chats__tooltip">WhatsApp</span>
      <div class="button-with-chats__svg-wrapper">
        <div class="button-with-chats__svg-bg"></div>
        <svg
          role="presentation"
          width="50"
          height="50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M25 50a25 25 0 100-50 25 25 0 000 50z" fill="#fff"></path>
          <path
            d="M26.1 12a12.1 12.1 0 00-10.25 18.53l.29.46-1.22 4.46 4.57-1.2.45.27a12.1 12.1 0 106.16-22.51V12zm6.79 17.22c-.3.85-1.72 1.62-2.41 1.72-.62.1-1.4.14-2.25-.14-.7-.22-1.37-.47-2.03-.77-3.59-1.57-5.93-5.24-6.1-5.48-.19-.24-1.47-1.97-1.47-3.76 0-1.79.93-2.67 1.25-3.03.33-.37.72-.46.96-.46.23 0 .47 0 .68.02.22 0 .52-.09.8.62l1.1 2.7c.1.18.16.4.04.64s-.18.39-.36.6c-.18.21-.38.47-.54.64-.18.18-.36.38-.15.74.2.36.92 1.55 1.98 2.52 1.37 1.23 2.52 1.62 2.88 1.8.35.18.56.15.77-.1.2-.23.9-1.05 1.13-1.42.24-.36.48-.3.8-.18.33.12 2.09 1 2.44 1.18.36.19.6.28.69.43.09.15.09.88-.21 1.73z"
            fill="#27D061"
          ></path>
          <path
            d="M25 0a25 25 0 100 50 25 25 0 000-50zm1.03 38.37c-2.42 0-4.8-.6-6.9-1.76l-7.67 2 2.05-7.45a14.3 14.3 0 01-1.93-7.2c0-7.92 6.49-14.38 14.45-14.38a14.4 14.4 0 110 28.79z"
            fill="#27D061"
          ></path>
        </svg>
      </div>
    </a>
    <a
      href="${i.socials.telegram.href}"
      class="button-with-chats__icon button-with-chats__link"
      target="_blank"
      data-telegram
    >
      <span class="button-with-chats__tooltip">Telegram</span>
      <div class="button-with-chats__svg-wrapper">
        <div class="button-with-chats__svg-bg"></div>
        <svg
          width="50"
          height="50"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50Zm21.977-68.056c.386-4.38-4.24-2.576-4.24-2.576-3.415 1.414-6.937 2.85-10.497 4.302-11.04 4.503-22.444 9.155-32.159 13.734-5.268 1.932-2.184 3.864-2.184 3.864l8.351 2.577c3.855 1.16 5.91-.129 5.91-.129l17.988-12.238c6.424-4.38 4.882-.773 3.34.773l-13.49 12.882c-2.056 1.804-1.028 3.35-.129 4.123 2.55 2.249 8.82 6.364 11.557 8.16.712.467 1.185.778 1.292.858.642.515 4.111 2.834 6.424 2.319 2.313-.516 2.57-3.479 2.57-3.479l3.083-20.226c.462-3.511.993-6.886 1.417-9.582.4-2.546.705-4.485.767-5.362Z"
            fill="#1d98dc"
          ></path>
        </svg>
      </div>
    </a>
  </div>
  `;
}
class C extends p {
  constructor(e) {
    super(e);
  }
  getEl() {
    return document.querySelector(`#${this.options.buttonId}`);
  }
  init() {
    this.initContainer(), this.listenClick(), this.listenSocials();
  }
  destroy() {
    this.destroyContainer();
  }
  initContainer() {
    super.initContainer(this.constructor.className, L);
  }
  listenClick() {
    this.getEl().addEventListener("click", () => this.loadScripts());
  }
}
n(C, "className", "button-with-chats-container");
class g {
  constructor(e, t) {
    n(this, "selector", "");
    n(this, "options", {});
    this.selector = e, this.options = t;
  }
  static make(e, t) {
    const s = new this(e, t);
    if (!s.getEl())
      throw new Error(`\u041D\u0435\u0442 DOM \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0441 \u0441\u0435\u043B\u0435\u043A\u0442\u043E\u0440\u043E\u043C: ${e}`);
    return s.init(), s;
  }
  getEl() {
    return document.querySelector(this.selector);
  }
  initDataLayer() {
    window.dataLayer || (window.dataLayer = []);
  }
}
class y extends g {
  constructor(e, t) {
    super(e, t);
  }
  getTriggers() {
    return this.getEl().querySelectorAll(
      `[${this.constructor.dataAttributeTrigger}]`
    );
  }
  init() {
    this.initDataLayer();
    const e = w.make(this.options), t = u.make(this.options);
    window.popupWithChats = {
      showCallback(s) {
        e.show(s);
      },
      showResponse(s) {
        t.show(s);
      }
    }, document.body.addEventListener("click", (s) => {
      for (let a = 0; a < s.composedPath().length; a++)
        if (s.composedPath()[a].hasAttribute && s.composedPath()[a].hasAttribute(this.constructor.dataAttributeTrigger)) {
          e.show({
            title: s.composedPath()[a].dataset.popupWithChatsTitle,
            callback: s.composedPath()[a].dataset.popupWithChatsCallback,
            name: s.composedPath()[a].dataset.popupWithChatsName,
            sourceId: s.composedPath()[a].dataset.popupWithChatsSourceId
          });
          break;
        }
    });
  }
}
n(y, "dataAttributeTrigger", "data-popup-with-chats");
class M extends g {
  constructor(t, s) {
    super(t, s);
    n(this, "button", null);
  }
  init() {
    this.initDataLayer(), this.button = C.make(this.options);
  }
  destroy() {
    this.button.destroy();
  }
}
export {
  M as ButtonWithChats,
  y as PopupWithChats,
  y as default
};
